import React, { useState } from 'react';
import { useCart, useDispatchCart } from '../components/ContextReducer';
import DeleteIcon from '@material-ui/icons/Delete';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Button from '@material-ui/core/Button';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Cart.css';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;


export default function Cart() {
  const data = useCart();
  const dispatch = useDispatchCart();
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);

  const handleCheckOut = () => {
    setPaymentModalOpen(true);
  };

  
  const handlePayment = async () => {
    const fullName = document.getElementById("fullName").value;
    const cardNumber = document.getElementById("cardNumber").value;
    const expiryDate = document.getElementById("expiryDate").value;
    const cvv = document.getElementById("cvv").value;
  
    if ( cardNumber === "" || expiryDate === "" || cvv === "" || fullName === "") {
      alert("Please fill in all the card details.");
      return;
    }
     if (!/^\d{16}$/.test(cardNumber)) {
    alert("Card number should be 16 digits.");
    return;
  }

  if (!/^\d{3}$/.test(cvv)) {
    alert("CVV should be 3 digits.");
    return;
  }
  
    const userEmail = localStorage.getItem("userEmail");
  
    const response = await fetch(`${BASE_URL}/api/auth/orderData`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        order_data: data,
        email: userEmail,
        order_date: new Date().toDateString()
      })
    });
  
    if (response.status === 200) {
      dispatch({ type: "DROP" });
    }
    setTimeout(() => {
      setPaymentSuccess(true);
    }, 2000);
  };
  
  const handleCancelPayment = () => {
    setPaymentModalOpen(false);
  };

  const handleRemoveItem = (index) => {
    dispatch({ type: 'REMOVE', index });
  };

  const handleRemoveAll = () => {
    dispatch({ type: 'DROP' });
  };

  const totalPrice = data.reduce((total, food) => total + food.price, 0);

  return (
    <div className="cart-container">
      <div className="cart-header">
        <ShoppingCartIcon className="cart-icon" />
        <Typography variant="h5" component="h2" className="cart-title">
          Cart
        </Typography>
      </div>
      {data.length === 0 ? (
        <div className="empty-cart">
          <Typography variant="subtitle1" component="p" className='text-white'>
            Your cart is empty.
          </Typography>
        </div>
      ) : (
        <div className="cart-items">
          {data.map((food, index) => (
            <div className="cart-item" key={index}>
              <div className="item-details">
                <Typography variant="subtitle1" component="p" className="item-name">
                  {food.name}
                </Typography>
                <Typography variant="body2" component="p" className="item-size">
                  Size: {food.size}
                </Typography>
              </div>
              <div className="item-controls">
                <Typography variant="subtitle1" component="p" className="item-qty">
                  Qty: {food.qty}
                </Typography>
                <Button
                  size="small"
                  className="remove-btn"
                  onClick={() => handleRemoveItem(index)}
                >
                  <DeleteIcon />
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
      {data.length > 0 && (
        <div className="cart-footer">
          <Typography variant="h6" component="p" className="text-white">
            Total Price: ₹{totalPrice}/-
          </Typography>
          <div className="cart-actions">
            <Button
              variant="contained"
              color="primary"
              className="checkout-btn bg-success"
              onClick={handleCheckOut}
            >
              Checkout
            </Button>
            <Button
              variant="contained"
              color="secondary"
              className="remove-all-btn"
              onClick={handleRemoveAll}
            >
              Remove All
            </Button>
          </div>
        </div>
      )}

      <Modal open={paymentModalOpen} onClose={handleCancelPayment}>
        <div className="payment-modal">
          {paymentSuccess ? (
            <div className="text-center row justify-content-center">
              <Typography variant="h6" component="h2" className="mb-5">
               <TaskAltIcon color="success" /> Payment Successful!
              </Typography>
              <Button
              className='w-50'
                variant="contained"
                onClick={() => {
                  setPaymentModalOpen(false);
                  dispatch({ type: 'DROP' });
                }}
              >
                Close
              </Button>
            </div>
          ) : (
            <div className="payment-form">
              <Typography variant="h6" component="h2" className=" text-black">
                Enter Card Details 
              </Typography>
              <div className="card-details row">
                <label htmlFor="fullName" ></label>
                <input type="text" id="fullName" placeholder="full name" className=" card-input" />

                <label htmlFor="cardNumber" ></label>
                <input type="number" id="cardNumber" placeholder="card number" className=" card-input" />

                <label htmlFor="expiryDate"></label>
                <input type="date" id="expiryDate" placeholder="expiry date" className=" card-input" />

                <label htmlFor="cvv"></label>
                <input type="number" id="cvv" placeholder='cvv' className=" card-input" />
              </div>
              <div className="payment-buttons">
                <Button
                  variant="contained"
                  color="primary"
                  className="btn btn-primary"
                  onClick={handlePayment}
                >
                  Process Payment
                </Button>
                <Button
                  variant="contained"
                  className="btn"
                  onClick={handleCancelPayment}
                >
                  Cancel
                </Button>
              </div>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
}
